import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c3235aa4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "node-condition-rule"
}
const _hoisted_2 = {
  key: 1,
  class: "color-dark-gray"
}
const _hoisted_3 = { class: "color-dark-gray" }
const _hoisted_4 = {
  key: 4,
  class: "color-dark-gray"
}

import i18n from "@/core/i18n/i18n";
import { displayValueClass as valueClass } from "@/flow/utils/stepInputSummary";
import type { ConditionRow } from "@/flow/utils/stepInputSummary";

interface IProps {
  rows: ConditionRow[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'NodeConditionRows',
  props: {
    rows: {}
  },
  setup(__props: any) {


const { t } = i18n.global;

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row, index) => {
    return (_openBlock(), _createElementBlock("div", {
      key: `condition-${index}`,
      class: "node-condition"
    }, [
      (row.rule)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(row.rule), 1))
        : _createCommentVNode("", true),
      (row.openParen)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, "("))
        : _createCommentVNode("", true),
      (row.left.text)
        ? (_openBlock(), _createElementBlock("span", {
            key: 2,
            class: _normalizeClass(_unref(valueClass)(row.left))
          }, _toDisplayString(row.left.text), 3))
        : _createCommentVNode("", true),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)(row.operatorLabelKey)), 1),
      (row.right.text)
        ? (_openBlock(), _createElementBlock("span", {
            key: 3,
            class: _normalizeClass(_unref(valueClass)(row.right))
          }, _toDisplayString(row.right.text), 3))
        : _createCommentVNode("", true),
      (row.closeParen)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, ")"))
        : _createCommentVNode("", true)
    ]))
  }), 128))
}
}

})